<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<p-toast></p-toast>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Lista de factores de emisión</h1>
      <p class="main-subtitle">
        Total de factores de emisión: {{ totalRecords }}
      </p>
    </div>
  </div>

  <app-emissions-factors-filter
    (filter)="handleFilter($event)"
    (clear)="handleClearFilters()"
  >
  </app-emissions-factors-filter>

  <app-emissions-factors-list
    [data]="filteredData"
    [factorMap]="factorMap"
    [variationMap]="variationMap"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    [first]="first"
    [rows]="pageSize"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    (pageChange)="handlePageChange($event)"
    (toggleSort)="handleToggleSort($event)"
  />
</div>
